import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/core/service/config.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit {

  @Input() lablPage: any;
  @Input() breadcrumbItem: any;
  @Input() breadcrumbItemActive: any;
  @Input() breadcrumbItemsList!: { url: string, title: string }[];

  constructor(public _config: ConfigService) { }

  ngOnInit(): void {

  }

}
